import React from 'react'
import PropTypes from 'prop-types'

import { OFFER_TYPES } from 'App/config'

const SectionCard = props => {
  const { icon, text, title } = props
  return (
    <article className="why-section-item">
      {icon && typeof icon === 'string' ? (
        <span className="iconify" data-inline="false" data-icon={icon} />
      ) : (
        icon
      )}
      <h3 className="fr-subtitle">{title}</h3>
      <div className="fr-desc">{text}</div>
    </article>
  )
}

const plFlagStyle = {
  border: '1px solid black',
  marginBottom: '1.5rem',
  maxWidth: 100,
}

const paymentProposalByOffer = {
  [OFFER_TYPES.NOT_SELLING]: (
    <SectionCard
      icon="fa-regular:money-bill-alt"
      title="Niska, przejrzysta stawka"
      text={
        <>
          <div>
            Nasza prowizja wynosi{' '}
            <span className="text-primary">jedynie 5%</span>.
          </div>
          <div>Płatność online - 1.5%.</div>
          <div>Brak kosztów stałych, dodatkowych, lub aktywacyjnych.</div>
        </>
      }
    />
  ),
  [OFFER_TYPES.WANT_TO_REDUCE_COST]: (
    <SectionCard
      icon="fa-regular:money-bill-alt"
      title="Niska, przejrzysta stawka"
      text={
        <>
          <div>
            Nasza prowizja wynosi{' '}
            <span className="text-primary">jedynie 5%</span>.
          </div>
          <div>Płatność online - 1.5%.</div>
          <div>Brak kosztów stałych, dodatkowych, lub aktywacyjnych.</div>
        </>
      }
    />
  ),
  [OFFER_TYPES.LUBJE]: (
    <SectionCard
      icon="fa-regular:money-bill-alt"
      title="Niska, przejrzysta stawka"
      text={
        <>
          <div>
            Nasza prowizja wynosi{' '}
            <span className="text-primary">jedynie 8%</span>.
          </div>
          <div>
            To prawie dwa razy mniej, niż w wypadku zagranicznych portali.
          </div>
          <div>Brak kosztów stałych, dodatkowych, lub aktywacyjnych.</div>
        </>
      }
    />
  ),
  [OFFER_TYPES.SELL_WITHOUT_COMMISSION]: (
    <SectionCard
      icon="fa-regular:money-bill-alt"
      title="Stały abonament"
      text={
        <>
          <div>
            Wybierz jeden z trzech pakietów i ciesz się przywidywalnym kosztem z
            miesiąca na miesiąc
          </div>
          <div>Płatność online - 1.5%.</div>
          <div>Brak kosztów aktywacyjnych.</div>
        </>
      }
    />
  ),
}

const OnlineOrdersBenefits = ({ type = OFFER_TYPES.WANT_TO_REDUCE_COST }) => {
  return (
    <div className="row">
      <SectionCard
        icon="mdi:clock-fast"
        title="Uruchomienie nawet w 1 dzień"
        text={
          <div>
            Zwiększymy Twoją sprzedaż w Sieci szybciej, niż inni odpiszą na
            Twojego maila
          </div>
        }
      />
      {paymentProposalByOffer[type]}
      {type !== OFFER_TYPES.LUBJE && (
        <SectionCard
          icon="mdi:web"
          title="Strona internetowa już od 0zł"
          text={
            <div>
              <div>
                Dziś, w dobie Internetu, profesjonalna strona restauracji to{' '}
                <span className="text-primary">wizytówka Twojej marki</span>.
              </div>
              <div>
                Poza profilem na portalu umożliwiamy uruchomienie własnej strony
                internetowej.
              </div>
            </div>
          }
        />
      )}
      <SectionCard
        icon="ic-sharp-menu-book"
        title="Dowolność w edycji menu"
        text={
          <>
            <div>
              Nie musisz czekać 2 tygodnie, na aktualizację menu. U nas możesz
              zrobić to <span className="text-primary">"od ręki"</span>.
            </div>
            <div className="mt-2">
              Wprowadzimy dla Ciebie podstawowe menu oraz nauczymy Cię nim
              zarządzać.
            </div>
          </>
        }
      />
      <SectionCard
        icon="ion:people"
        title="Budujesz bazę klientów"
        text={
          <>
            <div>
              Z naszym modułem marketingowym{' '}
              <span className="text-primary">zabezpieczysz się</span>, przed
              utratą zamawiającego oraz{' '}
              <span className="text-primary">zwiększysz skuteczność</span>{' '}
              kampanii marketingowych.
            </div>
          </>
        }
      />
      <SectionCard
        icon={
          <img
            src="/storage/img/flag-pl.svg"
            alt="Flaga Polski"
            style={plFlagStyle}
          />
        }
        title="Wspierasz polskie!"
        text={
          <>
            <div>
              Jesteśmy polską firmą, stworzoną z własnych środków, nie
              zagranicznych inwestorów.
            </div>
            <div>Żyjemy w Polsce i tutaj płacimy podatki.</div>
          </>
        }
      />
    </div>
  )
}

OnlineOrdersBenefits.propTypes = {
  type: PropTypes.oneOf(Object.values(OFFER_TYPES)),
}

export default OnlineOrdersBenefits
